import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import AdminLogin from './AdminLogin';

// What "1313mart.com/admin" itself resolves to: already logged in as an
// admin/staff account -> straight to the dashboard. Anyone else (or not
// logged in at all) -> the dedicated admin login page, never the regular
// customer login.
const AdminEntry = () => {
    const { loading, isAuthenticated, user } = useSelector((state) => state.user);

    if (loading !== false) return null;

    if (isAuthenticated && (user.role === "admin" || user.role === "staff")) {
        return <Navigate to="/admin/dashboard" />;
    }

    return <AdminLogin />;
};

export default AdminEntry;